export const resetFilters = (api) =>{
    Object.keys(api.getFilterModel()).length>0 && api.setFilterModel(null);
}

export const customFilter = (api,filter) =>{
    api.setFilterModel(filter);
}